import './App.css';
import Sidebar from './Sidebar';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useCookies } from 'react-cookie';
import './Main.css';
import { FaSearch } from "react-icons/fa";
import Background from './Background';
import { useState, useEffect } from 'react';
import { Link } from "react-router-dom";

function UserList() {
    const [cookies, setCookie] = useCookies(['user']);
    const [userList,setUserList] = useState([]);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [lastPage,setLastPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const getUserList = () => {
        var data = new FormData();
        
        data.append("sort_by","created_at");
        data.append("sorting_order", "desc");
        data.append("page",page);
        data.append("page_size",pageSize);
        if(searchTerm != "") {
            data.append("search_term", searchTerm);
        }
        setIsLoading(true);
        fetch('https://api.connecker.com/api/get_all_users', {
            method: 'POST',
            body: data
        }).then(res => {
            setIsLoading(false);
            if(!res.ok) {
                throw Error('Could not fetch');
            }
            return res.json();
         }).then(data => {
            setIsLoading(false);
            if(data.response_code == 200) {
               setUserList(data.data.data);
               setPage(data.page);
               setLastPage(data.last_page);
            } else if(data.response_code == 404) {
                setUserList([]);
            }
         });
    }

    const nextPage = () => {
        setPage(page+1);
    }

    const previousPage = () => {
        setPage(page-1);
    }

    useEffect(() => {
        const abortController = new AbortController();
        getUserList();
       },[page,pageSize, searchTerm]);

    return(
        <div className="content">
            <div className="row pb-2">
                <div className="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2">
                    <Sidebar></Sidebar>
                </div>
                <div className="col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 col-xxl-10" style={{ paddingLeft: "40px" }}>
                        <Background></Background>
                        <h4 className="heading" style={{ color:"white", marginTop:"50px" }}>User List</h4>
                        
                        {/* Filter Controls */}
                        <div className="card mb-3" style={{borderColor:"white", padding: "20px"}}>
                            <div className="row align-items-center">
                                <div className="col-md-3">
                                    <div className="d-flex align-items-center">
                                        <span className="me-2" style={{fontSize: "14px", color: "#666"}}>Show</span>
                                        <select 
                                            name="entries" 
                                            id="entries" 
                                            className="form-select form-select-sm"
                                            style={{width: "70px", fontSize: "14px"}}
                                            onChange={({ target: { value } }) => setPageSize(value)}
                                        >
                                            <option value="10">10</option>
                                            <option value="20">20</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select>
                                        <span className="ms-2" style={{fontSize: "14px", color: "#666"}}>entries</span>
                                    </div>
                                </div>
                                <div className="col-md-6"></div>
                                <div className="col-md-3">
                                    <div className="d-flex align-items-center justify-content-end">
                                        <span className="me-2" style={{fontSize: "14px", color: "#666"}}>Search:</span>
                                        <input 
                                            type="text" 
                                            id="listSearch" 
                                            className="form-control form-control-sm"
                                            style={{width: "150px", fontSize: "14px"}}
                                            placeholder="Search..."
                                            onChange={({ target: { value } }) => setSearchTerm(value)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Table */}
                        <div className="card" style={{borderColor:"white"}}>
                            <div className="table-responsive">
                                <table style={{width:"100%"}} className="table table-striped">
                                    <thead style={{backgroundColor: "#f8f9fa"}}>
                                        <tr style={{ borderBottom: "2px solid #dee2e6" }}>
                                            <th style={{color: "#666", fontWeight: "600", fontSize: "14px", padding: "12px 8px"}}>#</th>
                                            <th style={{color: "#666", fontWeight: "600", fontSize: "14px", padding: "12px 8px"}}>NAME</th>
                                            <th style={{color: "#666", fontWeight: "600", fontSize: "14px", padding: "12px 8px"}}>EMAIL</th>
                                            <th style={{color: "#666", fontWeight: "600", fontSize: "14px", padding: "12px 8px"}}>MOBILE</th>
                                            <th style={{color: "#666", fontWeight: "600", fontSize: "14px", padding: "12px 8px"}}>LATEST OTP</th>
                                            <th style={{color: "#666", fontWeight: "600", fontSize: "14px", padding: "12px 8px"}}>AGENT</th>
                                            <th style={{color: "#666", fontWeight: "600", fontSize: "14px", padding: "12px 8px"}}>ACTIONS</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            userList.map((user, i) => (
                                                    <tr key={user.id} style={{borderBottom: "1px solid #eee"}}>
                                                        <td style={{padding: "12px 8px", fontSize: "14px", color: "#333"}}>
                                                            {(page - 1) * pageSize + i + 1}
                                                        </td>
                                                        <td style={{padding: "12px 8px", fontSize: "14px", color: "#333"}}>
                                                            {user.middle_name != null && user.middle_name != "null" ? 
                                                                (user.first_name + " " + user.middle_name + " " + user.last_name) : 
                                                                (user.first_name + " " + user.last_name)
                                                            }
                                                        </td>
                                                        <td style={{padding: "12px 8px", fontSize: "14px", color: "#666"}}>
                                                            {user.email}
                                                        </td>
                                                        <td style={{padding: "12px 8px", fontSize: "14px", color: "#333"}}>
                                                            {user.mobile || '-'}
                                                        </td>
                                                        <td style={{padding: "12px 8px", fontSize: "14px", color: "#333"}}>
                                                            {user.latest_otp && user.latest_otp.token ? (
                                                                <span style={{
                                                                    padding: "4px 8px",
                                                                    backgroundColor: user.latest_otp.expired ? "#dc3545" : "#28a745",
                                                                    borderRadius: "4px",
                                                                    color: "white",
                                                                    fontSize: "12px",
                                                                    fontWeight: "600",
                                                                    fontFamily: "monospace"
                                                                }}>
                                                                    {user.latest_otp.token}
                                                                </span>
                                                            ) : (
                                                                <span style={{color: "#999", fontStyle: "italic"}}>No OTP</span>
                                                            )}
                                                        </td>
                                                        <td style={{padding: "12px 8px", fontSize: "14px", color: "#333"}}>
                                                            {user.email}
                                                        </td> 
                                                        <td style={{padding: "12px 8px"}}>
                                                            <Link 
                                                                to={`/user_details/${user.id}`}
                                                                style={{
                                                                    color: "#007bff",
                                                                    textDecoration: "none",
                                                                    fontSize: "14px",
                                                                    fontWeight: "500"
                                                                }}
                                                            >
                                                                View
                                                            </Link>
                                                        </td>
                                                    </tr>
                                            ))
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="row d-flex justify-content-between">
                            <div className="col-md-6 col-lg-6 col-xl-6 col-xxl-6">
                               
                            </div>
                            <div className="col-md-6 col-lg-6 col-xl-6 col-xxl-6">
                                <div>
                                    {((page > 1) && userList.length > 0) ? <button type="button" onClick={ previousPage } class="btn btn-outline-secondary">Previous</button> : <div></div> }
                                    {((lastPage > page) && userList.length > 0) ? <button type="button" style={{ color:"#FF4500" }} onClick={ nextPage } class="btn btn-outline-secondary">Next</button> : <div></div>}
                                </div>
                            </div>
                        </div>                
                    </div>
            </div>
        </div>
    );
}

export default UserList;